<template>
  <el-dialog
    title="请确认您的操作!"
    :visible.sync="dialogVisible"
    width="30%"
    center>
    <div align="center">
      <p>确定删除维修师傅</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDeleteHousekeepingServUserModel">点错了</el-button>
      <el-button type="primary" @click="deleteHousekeepingServUser">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteHousekeepingServUser } from '@/api/housekeeping/housekeepingServUserApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteHousekeepingServUser',
  data() {
    return {
      dialogVisible: false,
      deleteHousekeepingServUserInfo: {},
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
  },
  methods: {
    open(data) {
      this.deleteHousekeepingServUserInfo = data
      this.dialogVisible = true
    },
    async deleteHousekeepingServUser() {
      try {
        this.deleteHousekeepingServUserInfo.shopId = this.shopId
        const res = await deleteHousekeepingServUser(this.deleteHousekeepingServUserInfo)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('请求失败:', error)
        this.$message.error('删除失败')
      }
    },
    closeDeleteHousekeepingServUserModel() {
      this.dialogVisible = false
    }
  }
}
</script>